import colormap from '../data/colourdict.json';
import shapemap from '../data/shapedict.json';
import resmap from '../data/resdict.json';
import { genSVG } from './parser';

//Returns SVG of SNFG with scaling for use in database.
function SNFGsvg({snfg}) {
  // Handle unknown sugars gracefully
  if (!snfg || !resmap[snfg]) {
    // Return a default unknown sugar shape (gray circle with question mark)
    return (
      <div
        style={{
          width:'3vh',
          height:'3vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#e0e0e0',
          border: '2px dashed #999',
          borderRadius: '50%',
          fontSize: '1.5vh',
          color: '#666',
          fontWeight: 'bold'
        }}
        title={`Unknown sugar: ${snfg || 'N/A'}`}
      >
        ?
      </div>
    );
  }

  return (
    <div style={{width:'3vh', height:'auto'}} className="network panelcontent svg"
    viewbox="0 0 30 30" key={snfg} dangerouslySetInnerHTML={{ __html: genSVG(resmap[snfg].shape, resmap[snfg].colour).svg }} />
  );
}

export default SNFGsvg;